module.exports = __webpack_public_path__ + "static/media/minus-alt.ad80d419.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/minus-alt.svg
// module id = 555
// module chunks = 0